<template>
    <div>

        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <!-- Add Item form -->       
        <div>
            <button type="button" class="btn btn-primary btn-lg mt-4" @click.prevent="showAddForm">+ Новый Курс</button>
        </div>
        <div class="modal fade" id="addForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Создать новый Курс</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <div class="form-group">
                            <label for="name" class="col-form-label">Название:</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationAdd && errors.validationAdd.name">
                                {{ errors.validationAdd.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelAdding">Отмена</button>
                        <button type="button" class="btn btn-primary" @click.prevent="addRecord">Ок</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.add">
                        {{ errors.add }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Add Item form -->


        <!-- Модальное окно для подтверждения удаления -->
        <ModalOkCancel v-bind:data="ModalOkCancelData" v-on:mrok="deleteRecord2"/>



        <!-- Фильтрация данных -->
        <!--
        <div class="row mt-4">
            <div class="form-group col">
                <label for="department">Состояние:</label>
                <select class="form-control" name="coursestate" id="coursestate" v-model="f_coursestate_id">
                    <option value="-1" :selected="true">Все</option>
                    <option v-for="item in coursestates" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            <div class="form-group col">
                <label for="name">Название:</label>
                <input class="form-control" type="text" name="name" id="name" v-model="f_name">
            </div>
        </div>
        -->




        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>
            <table class="table mt-4 bg-light shadow p-3 mb-5 rounded">
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <p>Наименование</p>
                            <input class="form-control" type="text" name="name" id="name" v-model="f_name">
                        </th>
                        <th>
                            <p>Состояние</p>
                            <select class="form-select form-select-sm form-control" name="coursestate" id="coursestate" v-model="f_coursestate_id">
                                <option value="-1" :selected="true">Все</option>
                                <option v-for="item in coursestates" :key="item.id" :value="item.id">{{ item.name }}</option>
                            </select>
                        </th>
                        <th>
                            <p>Кафедра</p>
                            <select class="form-select form-select-sm form-control" name="department" id="department" v-model="f_department_id">
                                <option value="-1" :selected="true">Все</option>
                                <option v-for="item in departments" :key="item.id" :value="item.id">{{ item.name }}</option>
                            </select>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredData" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td><router-link :to="{ name: 'adminCourse_show', params: { id: item.id } }">{{ item.name }}</router-link></td>

                        <td>{{ item.coursestate_name }}</td>
                        <td>{{ item.department_name }}</td>
                        <td>
                            <ul class="nav nav-pills">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">&#9776;</a>
                                    <div class="dropdown-menu">
                                        <router-link class="alert alert-primary dropdown-item" :to="{ name: 'adminCourse_edit', params: { id: item.id } }">Редактировать Курс</router-link>
                                        <div class="dropdown-divider"></div>
                                        <router-link class="dropdown-item" :to="{ name: 'adminCourse_chapters', params: { course_id: item.id } }">Открыть список глав</router-link>
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="btn dropdown-item" @click.prevent="publicCourse(item.id)">Опубликовать</button>
                                        <button type="button" class="btn dropdown-item" @click.prevent="unpublicCourse(item.id)">Снять с публикации</button>
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="btn dropdown-item" @click.prevent="archiveCourse(item.id)">Отправить в архив</button>
                                        <button type="button" class="btn dropdown-item" @click.prevent="unarchiveCourse(item.id)">Достать из архива</button>
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="alert alert-danger dropdown-item" @click.prevent="askToDeleteRecord(item)">УДАЛИТЬ</button>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>
        </div>
    </div>
    
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import ModalOkCancel from '@/components/ModalOkCancel'
import PageTitle from '@/components/PageTitle'

import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            title: 'Список Курсов',
            data: [],
            coursestates: [],
            departments: [],
            id: 0,
            name: '',
            errors: {load: '', add: '', delete: '', edit: '', validationAdd: {}, validationEdit: {}, any: ''},
            ModalOkCancelData: { id: 0, caption: '', message: '', show: false, style: '', okCaption: 'Удалить!' },

            // для фильтрации:
            f_coursestate_id: -1,
            f_department_id: -1,
            f_name: '',
            
        }
    },
   async mounted() {
       this.loadRecords()
    },


    computed: {
        filteredData() {
            return this.data.filter(rec => 
                (
                    rec.name.toLowerCase().includes(this.f_name.toLowerCase())
                    &&
                    ((rec.coursestate_id == this.f_coursestate_id) || (this.f_coursestate_id == -1))
                    &&
                    ((rec.department_id == this.f_department_id) || (this.f_department_id == -1))
                )
            )
        }
    },

    methods: {

        clearErrors() {
            this.errors.load = '';
            this.errors.add = '';
            this.errors.delete = '';
            this.errors.edit = '';
            this.errors.any = '';
        },



        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/courses')
                this.data = response.data.courses
                this.coursestates = response.data.coursestates
                this.departments = response.data.departments
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },

        showAddForm() {
            this.name = ''
            this.errors.validationAdd = {}
            this.clearErrors();
            jQuery('#addForm').modal('show')
        },
        cancelAdding() {
            this.name = ''
            jQuery('#addForm').modal('hide')
        },

        //
        // Add new record.
        //
        async addRecord() {
            this.errors.validationAdd = {}
            this.clearErrors();
            try {
                let response = await axios.post('admin/courses', {name: this.name})
                if (response.status == 200) {
                    this.name = ''
                    this.loadRecords()
                    jQuery('#addForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationAdd = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.add = "Ошибка при создании записи."
                }
                else {
                    this.errors.add = "Неизвестная ошибка при создании записи."
                }
            }
        },

        //
        // Delete record.
        //
        /*

            !!! Старая ф-ция удаления, без подтверждения.

        async deleteRecord(id) {
            this.clearErrors();
            try {
                let response = await axios.delete('admin/courses/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },
        */


        //
        // Показываем MessageBox с подтверждением удаления.
        //
        askToDeleteRecord(item) {
            this.clearErrors();
            this.ModalOkCancelData.id = item.id
            this.ModalOkCancelData.style = 'danger'
            this.ModalOkCancelData.caption = 'Внимание!'
            this.ModalOkCancelData.message = 'Вы действительно хотите удалить запись <strong>"' + item.name + '"</strong>?'
            this.ModalOkCancelData.show = true;
        },

        //
        // Удаление.
        //
        async deleteRecord2()
        {
            this.clearErrors();
            var id = arguments[0];
            if (id > 0) {
                try {
                    let response = await axios.delete('admin/courses/'+id)
                    if (response.status == 200) {
                        // удаление эл-та из списка "на клиенте":
                        let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                        this.data.splice(index, 1)            
                    }
                }
                catch (e) {
                    if (e.response.status == 520) {
                        this.errors.delete = e.response.data.error
                    }
                    else {
                        this.errors.delete = 'Неизвестная ошибка при удалении.'
                    }
                }
            }
        },

        //
        // Опубликовать Курс.
        //
        async publicCourse(id) {
            this.clearErrors();
            //this.errors.any = ''
            try {
                let response = await axios.post('admin/courses/'+id+'/action/public')
                if (response.status == 200) {
                    this.loadRecords()
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при публикации курса."
                }
            }
        },


        //
        // Снять Курс с публикации (вернуть в Черновики).
        //
        async unpublicCourse(id) {
            this.clearErrors();
            //this.errors.any = ''
            try {
                let response = await axios.post('admin/courses/'+id+'/action/unpublic')
                if (response.status == 200) {
                    this.loadRecords()
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при снятии курса с публикации."
                }
            }
        },




        //
        // Отправить Курс в архив.
        //
        async archiveCourse(id) {
            this.clearErrors();
            //this.errors.any = ''
            try {
                let response = await axios.post('admin/courses/'+id+'/action/archive')
                if (response.status == 200) {
                    this.loadRecords()
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при архивации курса."
                }
            }
        },


        //
        // Вернуть Курс из архива.
        //
        async unarchiveCourse(id) {
            this.clearErrors();
            try {
                let response = await axios.post('admin/courses/'+id+'/action/unarchive')
                if (response.status == 200) {
                    this.loadRecords()
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при разархивации курса."
                }
            }
        },

    },
   
    components: {
        Loader,
        ModalOkCancel,
        PageTitle,
    }
}
</script>